<template>
  <div style="height: 700px; overflow: auto">
    <Form :rules="ruleFrom" :label-width="120" class="order-details" disabled>
      <template v-if="!orderShow.orderMsg">
        <Divider orientation="left">{{ $t("orderInfo") }}</Divider>
        <div class="from_div">
          <Row>
            <Col span="6">
              <FormItem :label="$t('order_userRef')" prop="shipperRef">
                <Input
                  disabled
                  v-model="orderDetails.client_refer_code"
                ></Input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem :label="$t('shipperRef')" prop="shipperRef">
                <Input disabled v-model="orderDetails.airway_number"></Input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem :label="$t('orderservice')" prop="shipperRef">
                <Input disabled v-model="orderDetails.cod_type"></Input>
                <!-- <Select v-model="orderDetails.cod_type" disabled="disabled">
                  <Option v-for="item in serviceList" :value="item" :key="item">{{
                    item
                  }}</Option>
                </Select> -->
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem :label="$t('order_price')" prop="shipperRef">
                <Input disabled v-model="orderDetails.cod_amount"></Input>
              </FormItem>
            </Col>

            <!-- <Col span="6">
                      <FormItem :label="$t('packageType')" prop="shipperRef">
                          <Select v-model="orderDetails.product" disabled="disabled">
                              <Option v-for="item in packageTypeRadio" :value="item" :key="item">{{ item }}</Option>
                          </Select>
                      </FormItem>
                      </Col> -->
            <!-- <Col span="8">
              <FormItem :label="$t('battery')" prop="shipperRef">
                <Select v-model="orderDetails.battery" disabled="disabled">
                  <Option v-for="item in batteryList" :value="item" :key="item">{{
                    item
                  }}</Option>
                </Select>
              </FormItem>
            </Col> -->
            <Col span="6">
              <FormItem :label="$t('order_pcs')" prop="shipperRef">
                <Input v-model="orderDetails.quantity" disabled></Input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem :label="$t('order_weight')" prop="shipperRef">
                <Input
                  :value="orderDetails.claim_weight"
                  disabled
                  style="width:85%;float:left"
                ></Input>
                <span style="width:10%;float:left;margin-left:5%">KG</span>
              </FormItem>
            </Col>
            <!-- <Col span="6">
                      <FormItem :label="$t('contraband')">
                          <Select v-model="orderDetails.contraband_id" disabled>
                              <Option v-for="item in objContraband" :value="item.contraband_code" :key="item.id">{{
                                  item.contraband_description }}</Option>
                          </Select>
                      </FormItem>
                      </Col> -->
            <Col span="24">
              <FormItem :label="$t('order_desc')" prop="shipperRef">
                <Input
                  type="textarea"
                  disabled
                  v-model="orderDetails.remarks"
                  :rows="2"
                ></Input>
              </FormItem>
            </Col>
          </Row>
        </div>
      </template>
      <template v-if="!orderShow.recipientMsg">
        <Divider orientation="left">{{ $t("reInfo") }}</Divider>
        <div class="from_div">
          <Row :gutter="10">
            <Col span="8">
              <FormItem :label="$t('clientCompany')" prop="shipperRef">
                <Input v-model="orderDetails.consignee" disabled></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('shipperName')" prop="shipperRef">
                <Input
                  v-model="orderDetails.consignee_contact"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('from_country')" prop="shipperRef">
                <Input :value="orderDetails.from_country"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('target_country')" prop="shipperRef">
                <Input :value="orderDetails.to_country"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('city_name')" prop="shipperRef">
                <Input :value="orderDetails.city_name"></Input>
              </FormItem>
            </Col>
            <!-- <Col span="8">
                      <FormItem :label="$t('channel_code')" prop="shipperRef">
                          <Input v-model="orderDetails.transport_mode" disabled></Input>
                      </FormItem>
                      </Col> -->

            <Col span="8">
              <FormItem :label="$t('order_phone')" prop="shipperRef">
                <Input
                  v-model="orderDetails.consignee_cellular"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('order_phone1')" prop="shipperRef">
                <Input
                  v-model="orderDetails.consignee_telephone"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <!-- </Row> -->
            <!-- <Row> -->
            <Col span="24">
              <FormItem :label="$t('order_address')" prop="shipperRef">
                <Input
                  type="textarea"
                  disabled
                  v-model="orderDetails.consignee_address"
                  :rows="2"
                ></Input>
              </FormItem>
            </Col>
            <!-- <Col span="12">
            <FormItem :label="$t('order_address1')" prop="shipperRef">
              <Input
                type="textarea"
                v-model="orderDetails.consignee_address2"
                placeholder="Please Enter address2"
                :rows="3"
              ></Input>
            </FormItem>
          </Col> -->
          </Row>
        </div>
      </template>
      <template v-if="!orderShow.goodsMsg">
        <Divider orientation="left">{{ $t("CargoInfo") }}</Divider>
        <div class="from_div">
          <Table border :columns="tablehead" :data="orderDetails.goods"></Table>
        </div>
      </template>
    </Form>
  </div>
</template>

<script>
export default {
  props: {
    orderDetails: {
      type: Object
    },
    orderShow: {
      type: Object,
      default: () => {
        return {
          orderMsg: false,
          recipientMsg: false,
          goodsMsg: false
        };
      }
    }
  },
  data() {
    return {
      serviceList: ["NCND", "NOR"],
      packageTypeRadio: ["XPS", "DOX"],
      ruleFrom: {
        shipperRef: [
          {
            required: true,
            message: "",
            trigger: "blur"
          }
        ]
      }
      // objContraband: {},
      // objCountry: {},
      // objCity: {},
    };
  },
  computed: {
    tablehead() {
      let columns = [];
      columns.push({
        title: this.$t("invoiceName"),
        key: "title",
        align: "center"
      });
      columns.push({
        title: this.$t("invoicePCS"),
        key: "quantity",
        align: "center"
      });
      columns.push({
        title: this.$t("invoiceWeight"),
        key: "weight",
        align: "center"
      });
      columns.push({
        title: this.$t("invoiceInsValue"),
        key: "values",
        align: "center"
      });
      columns.push({
        title: this.$t("invoiceDescription"),
        key: "description",
        align: "center"
      });
      columns.push({
        title: this.$t("invoiceHSCod"),
        key: "hs_code",
        align: "center"
      });
      return columns;
    },
    objContraband() {
      return this.$store.state.app.contraband;
    },
    objCountry() {
      return this.$store.state.app.country;
    },
    objCity() {
      return this.$store.state.app.city;
    }
  },
  mounted() {}
};
</script>

<style lang="less">
.from_div {
  border: 1px solid #e8eaec;
  padding: 30px 10px 10px;
  margin-top: -28px;
  border-top: none;
}
</style>
